import { render, staticRenderFns } from "./address-layout.vue?vue&type=template&id=041a18b0"
import script from "./address-layout.vue?vue&type=script&lang=js"
export * from "./address-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports